// extracted by mini-css-extract-plugin
export default {"container":"cete1q","empty":"ex4YgN","highQualityFrame":"Epa8Ug","lowQualityFrame":"hHw66W","thumbText":"nIb7Tl"};